<template>
  <div class="empty-box">
    <div class="image-box">
      <img :src="emptyImage" />
      <p :style="{ marginTop: textTop }">{{ text }}</p>
    </div>
  </div>
</template>

<script>
import emptyImage from '@/assets/images/common/empty-image.png'
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据'
    },
    textTop: {
      type: String,
      default: '-10%'
    },
    emptyImage:{
      default :emptyImage
    }
  },
  data() {
    return {
    }
  }
}
</script>


<style lang="less" scoped>
  .empty-box{
    box-sizing: border-box;
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .image-box{
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      p{
        text-align: center;
        height: 30px;
        line-height: 30px;
        margin-top: -10%;
        font-size: 14px;
        font-weight: 500;
        color: #b0b1b3;
      }
    }
  }
</style>

